import { render, staticRenderFns } from "./FormatItalicIcon.vue?vue&type=template&id=17e4ce16"
import script from "./FormatItalicIcon.vue?vue&type=script&lang=js"
export * from "./FormatItalicIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports